import React, { useState, useContext } from 'react';
import {useAuth} from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { Button, TextField, Container, Typography,CssBaseline, AppBar,Toolbar, BottomNavigation } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { Box, Grid } from '@mui/material';


const LoginUser = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const theme = useTheme();
  const { login } = useAuth();

  const navigate = useNavigate();


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await login(username, password);
      navigate('/dashboard');
    } catch (error) {
      console.log("Error something happened")
    }
  };
  

const goToRegister = ()=>{
  navigate('/create_user')
}

  // ...

  return (
    <>
      <AppBar position="static" style={{ background: theme.palette.primary.main }}>
      <Toolbar>
        <Typography variant="h6" style={{ flexGrow: 1, color: theme.palette.text.primary }}>
          Bizzence
        </Typography>
      </Toolbar>
    </AppBar>
    <Container component="main" maxWidth="md" >
      
    <CssBaseline />

    {/* Branding Section */}
    

    {/* Login Section */}
    <Box 
          sx={{ 
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            height: '80vh',
          }}
        >
      
     
      <Box 
  component="form" 
  onSubmit={handleSubmit} 
  noValidate 
  sx={{ 
    mt: 3, 
    width: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    flexDirection: 'column',
    border: '1px solid black', // This line adds the black border
    borderRadius: '5px',      // This line rounds the corners of the border
    padding: '48px'           // This adds some space inside the border
  }}
>
      <Typography component="h1" variant="h4" color="common.black">
        Bizzence
      </Typography>
      <Typography component="h2" variant="subtitle1" color="common.black"style={{marginTop: 8}}>
        Elevating your business sense and science.
      </Typography>
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          id="username"
          label="Email Address"
          name="username"
          autoComplete="email"
          autoFocus
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          sx={{ 
            mb: 2,
            '& .MuiOutlinedInput-input': {
              color: theme.palette.text.secondary, // Text color
            },
            '& .MuiOutlinedInput-root': {
              backgroundColor: theme.palette.white[50], // Light grey background
            },
          }}
        />
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="password"
          label="Password"
          type="password"
          id="password"
          autoComplete="current-password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          sx={{ 
            '& .MuiOutlinedInput-input': {
              color: theme.palette.text.secondary,
            },
            '& .MuiOutlinedInput-root': {
              backgroundColor: theme.palette.grey[50],
            },
          }}
        />
        <Button
          type="submit"
          fullWidth
          variant="contained"
          color="primary"
          sx={{ mt: 3, mb: 2 }}
        >
          Login
        </Button>
        <Grid container justifyContent="flex-end">
          <Grid item>
            <Button onClick={goToRegister} color="primary">
              Don't have an account? Register
            </Button>
          </Grid>
        </Grid>
      </Box>
    </Box>
  </Container>
  
  </>
  );

};

export default LoginUser;
